/** t494u: pick where journey updates are posted. Real, live channels only; a configured channel that was archived or
 * deleted shows as "Channel no longer exists" until someone picks another (updates meanwhile fall back a level). */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { Select } from '@/components/ui';
import { fleetKey } from './fleetUi';

export function useDeliveryChannels() {
  const ws = useWorkspaceId();
  return useQuery({ queryKey: fleetKey(ws, 'delivery-channels'), enabled: Boolean(ws), queryFn: () => api.fleet.deliveryChannels(ws!) });
}

export function DeliveryChannelSelect({ value, onChange, missing, blankLabel, testId }: { value: string | null; onChange: (id: string | null) => void; missing?: boolean; blankLabel: string; testId?: string }) {
  const ws = useWorkspaceId();
  const q = useQuery({ queryKey: ['channels-browse', ws], enabled: Boolean(ws), queryFn: () => api.browseChannels(ws!), staleTime: 60_000 });
  const live = (q.data?.channels ?? []).filter(c => c.kind === 'channel' && !c.archived_at).sort((a, b) => (a.title ?? a.slug ?? '').localeCompare(b.title ?? b.slug ?? ''));
  const gone = Boolean(value && (missing || (q.data && !live.some(c => c.id === value))));
  return (
    <>
      <Select value={value ?? ''} onChange={e => onChange(e.target.value || null)} data-testid={testId} aria-invalid={gone || undefined}>
        <option value="">{blankLabel}</option>
        {gone && value && <option value={value}>Channel no longer exists</option>}
        {live.map(c => <option key={c.id} value={c.id}>#{c.title ?? c.slug}</option>)}
      </Select>
      {gone && <p className="mt-1 text-xs text-rose-600" data-testid={testId ? `${testId}-missing` : undefined}>Channel no longer exists. Pick another channel.</p>}
    </>
  );
}
